import script from "./TrafficBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficBoard.vue?vue&type=script&setup=true&lang=js"

import "./TrafficBoard.vue?vue&type=style&index=0&id=4d6dac71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6dac71"]])

export default __exports__